import {Checkbox, CheckboxProps, Stack, Typography} from '@mui/material';
import {styled, SxProps} from '@mui/material/styles';
import {FC} from 'react';

interface Props {
  label?: string;
  checked?: CheckboxProps['checked'];
  onChange?: CheckboxProps['onChange'];
  size?: CheckboxProps['size'];
  disabled?: boolean;
  containerSx?: SxProps;
  textColor?: string;
}

const DEFAULT_LABEL = 'Отображать архивные контракты';

export const ArchiveCheckbox: FC<Props> = ({
  checked,
  onChange,
  label = DEFAULT_LABEL,
  disabled,
  containerSx,
  textColor,
  size,
}) => {
  return (
    <ArchiveCheckboxContainer sx={containerSx}>
      <Checkbox size={size} checked={checked} onChange={onChange} disabled={disabled} />
      <ArchiveCheckboxLabel textColor={textColor}>{label}</ArchiveCheckboxLabel>
    </ArchiveCheckboxContainer>
  );
};

const ArchiveCheckboxContainer = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
});

const ArchiveCheckboxLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{textColor?: string}>(({textColor = '#7E8285'}) => ({
  color: textColor,
}));
